import angular from 'angular' 
import packageModalCtrl from './packageModalCtrl'
import {
    org
} from 'redevConfig'


const add = (org && org.add) || ''
const list = (org && org.list) || ''
const detail = (org && org.detail) || ''

const orgListCtrl = list ? require(`redevelopment/system/org/${list.controllerName}`) : require('./orgListCtrl')
const orgAddCtrl = add ? require(`redevelopment/system/org/${add.controllerName}`) : require('./orgAddCtrl')
const orgDetailCtrl = detail ? require(`redevelopment/system/org/${detail.controllerName}`) : require('./orgDetailCtrl')
const orgListPage = list ? require(`redevelopment/system/org/${list.templateName}`) : require('./view/orgList.html')
const orgAddPage = add ? require(`redevelopment/system/org/${add.templateName}`) : require('./view/orgAdd.html')
const orgDetailPage = detail ? require(`redevelopment/system/org/${detail.templateName}`) : require('./view/orgDetail.html')

function configRouter($stateProvider) {
    $stateProvider.state(
    'system.syssetting.org',
    {
        url: '/org',
        template: '<div><div ui-view></div></div>',
        abstract: true, 
        default: 'system.syssetting.org.list',
        title: '机构管理',
    }) 
    $stateProvider.state( 
        'system.syssetting.org.list',
        {
            url: '/list',
            template: orgListPage,
            controller: 'orgListCtrl',
        }
    )
    // 编辑机构
    $stateProvider.state(
        'system.syssetting.org.detail',
        {
            url: '/detail/:orgId',
            template: orgDetailPage,
            controller: 'orgDetailCtrl',
            title: '详情',
        }
    )
    // 新增机构
    $stateProvider.state(
        'system.syssetting.org.add',
        {
            url: '/add/:orgId',
            template: orgAddPage,
            controller: 'orgAddCtrl',
            title: '新增',
        }, 
    )
    // 编辑机构
    $stateProvider.state(
        'system.syssetting.org.edit',
        {
            url: '/edit/:orgId',
            template: orgAddPage,
            controller: 'orgAddCtrl',
            title: '编辑',
        }, 
    )
}

export default angular
    .module('system.syssetting.org', [])
    .config(['$stateProvider', configRouter]) 
    .controller('orgDetailCtrl', orgDetailCtrl.default)
    .controller('orgAddCtrl', orgAddCtrl.default)
    .controller('orgListCtrl', orgListCtrl.default)
    .controller('packageModalCtrl',packageModalCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/org/index.js